export const VALID_TAXONOMY_CATEGORIES = ['predefined', 'demographic_age', 'demographic_gender', 'location'] as const;

export const TAXONOMY_METADATA_CATEGORIES_WITH_DIRECT = [...VALID_TAXONOMY_CATEGORIES, 'direct'] as const;
